const content = {
	title: 'Template name',
	textBody:
		'You can change the name of your template to something more memorable, like ‘Staff payroll’ or ‘Monthly invoices’.',
	duplicateWarning:
		'Sorry, a template’s already been set up with this name. Please choose another name then try again.',
};

export default content;
